import React from 'react'
import { observer } from 'mobx-react'
import clsx from 'clsx'
import { Marker } from '@instacart/tds'
import { ArrowRightIcon } from '@instacart/ids-core'
import { useActionFlow } from '~shared/lib/ActionFlow'
import catalogStore from '../../../Stores/CatalogStore'
import styles from '../ManageMenuModal.module.scss'

export const MenuItemRow: React.FC<{
  itemId: string
  disabled?: boolean
}> = observer(({ itemId, disabled }) => {
  const { navigate } = useActionFlow()
  const item = catalogStore.getItemById(itemId)

  if (!item) return null

  const { Name, IsAvailableToday } = item

  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled || undefined}
      onClick={() => {
        if (disabled) return
        navigate(`/item/${itemId}`)
      }}
      onKeyDown={e => {
        if (disabled) return
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          navigate(`/item/${itemId}`)
        }
      }}
      className={clsx(styles.menuItemTile, disabled && styles.disabled)}
    >
      <div className={styles.menuItemLeft}>
        <div className={styles.menuItemTitle}>{Name}</div>
        <div className={styles.menuItemMarker}>
          <Marker
            text={IsAvailableToday ? 'Available' : 'Unavailable'}
            variant={IsAvailableToday ? 'success' : 'detrimental'}
          />
        </div>
      </div>

      <div className={styles.menuItemRight}>
        <ArrowRightIcon className={styles.menuItemChevron} />
      </div>
    </div>
  )
})
